module.exports = __webpack_public_path__ + "static/media/solution12.2dd5bbc2.jpeg";